<template>
  <div class="footer">
    <div class="orange">
      <span>©2020-2026小橙家教</span>
      <span style="margin-left: 10px">蜀ICP备2020035072号</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MainFooter',
  components: {},
  props: {
    msg: String
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
.footer {
  width: 100%;
  height: 90px;
  background-color: #ffffff;

  .orange {
    text-align: center;
    height: 90px;
    font-size: 11px;
    line-height: 90px;
    color: #d2d2d2;
  }
}
</style>
